import moment from 'moment';

/**
 * Generate standard file name for exported CSV file.
 * The output will be in the following format:
 * - `{name} - {startDate} - {endDate} - {outlet.name}`
 *
 * If `startDate` equals `endDate`, `endDate` will be omitted.
 * If more than 1 outlet is passed, "All Outlets" will be printed.
 *
 * FIXME: handle edge cases (empty outlet, invalid dates)
 *
 * @param {moment.Moment} startDate Starting date for the data.
 * @param {moment.Moment} endDate Ending date for the data.
 * @param {string} name Base name of the file.
 * @param {string[]} outlet Ids for selected outlets.
 * @param {object[]} outlets All outlets.
 * @param {boolean} allDay Include time format if allDay is false.
 * @returns {string}
 */
export function csvName(startDate, endDate, name, outlet, outlets, allDay) {
  let outletName;
  if (outlet.length > 1) {
    outletName = 'All Outlets';
  } else {
    for (let i = 0; i < outlets.length; i++) {
      if (outlet[0] === outlets[i].id) {
        outletName = outlets[i].name;
      }
    }
  }

  const format = getDateFormat(allDay);
  let dateLabel = '';
  if (startDate.isSame(endDate, 'days')) {
    dateLabel = allDay
      ? moment(startDate).format(format)
      : [
          moment(startDate).format(format),
          moment(endDate).format('HH:mm:ss'),
        ].join(' - ');
  } else {
    dateLabel = [
      moment(startDate).format(format),
      moment(endDate).format(format),
    ].join(' - ');
  }

  const filename = `${name} - ${dateLabel} - ${outletName}`;
  return filename;
}

/**
 * Generate format of a date.
 * if the date includes time (allDay = false), 'DD-MM-YYYY HH:mm:ss' will be returned.
 * if the date without time (allDay = true), 'DD-MM-YYYY' will be returned.
 *
 * @param {boolean} allDay Include time format if allDay is false.
 * @returns {string}
 */
function getDateFormat(allDay) {
  const dateFormat = 'DD-MM-YYYY';
  const timeFormat = 'HH:mm:ss';
  return allDay ? dateFormat : `${dateFormat} ${timeFormat}`;
}
